import styled from "styled-components";

import colors from "core/colors";
import { textMd } from "core/fontStyles";
import { BlueBorderBottomLinkStyle } from "core/Typography";
import { focusOutline } from "core/links";

import { convertPxToRem } from "frontend/components/helpers";

export const CancelButton = styled.button`
    cursor: pointer;
    padding: 0;
    margin: 0 0 0 ${convertPxToRem({ px: 16 })};
    background: transparent;
    border: 0;
    ${BlueBorderBottomLinkStyle}
    ${textMd}

    &&, &:visited {
        color: ${colors.primary.diamond};
        border-color: ${colors.primary.diamond};

        &:hover {
            color: ${colors.primary.snow};
            border-color: ${colors.primary.snow};
        }

        // only show focus on keyboard not with mouse:
        &:focus:not(.focus-visible) {
            outline: none;
            box-shadow: none;
            border-top: none;
            border-right: none;
            border-left: none;
        }

        &:focus {
            ${focusOutline}
        }
    }
`;
